import React, { Component } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  mode,
  setDarkMode,
  params,
  StatusTnx,
} from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

// หน้าจำลองผล deposit (sandbox เท่านั้น)
// เข้าถึงจากการสแกน QR ที่ ApiPartner สร้างตอนสร้าง deposit เมื่อไม่ใช่ production
// URL: /deposit-test?data=base64("<reference_id>:<expired_ms>")
// ปุ่ม success / cancel / mismatch -> backend อัปเดตสถานะ แล้วยิง callback ไปหา broker ให้ทันที
const ACTIONS = [
  {
    status: "success",
    label: "Success",
    className: "btn-success",
    detail: "Mark this deposit as paid and send a success callback to the broker.",
  },
  {
    status: "cancel",
    label: "Cancel",
    className: "btn-danger",
    detail: "Reject this deposit and send a cancel callback to the broker.",
  },
  {
    status: "mismatch",
    label: "Mismatch",
    className: "btn-mismatch",
    style: { backgroundColor: "#6f42c1", borderColor: "#6f42c1", color: "#fff" },
    detail:
      "Mark this deposit as paid from a different bank account and send a mismatch callback to the broker.",
  },
];

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-GB", { hour12: false });
};

export default class DepositTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: params("data") || "",
      transaction: null,
      invalid: false,
      submitting: "",
    };
  }

  async componentDidMount() {
    if (mode === "dark") setDarkMode();
    await this.Get();
  }

  componentDidUpdate() {
    if (mode === "dark") setDarkMode();
  }

  Get = async () => {
    const { data } = this.state;
    if (!data) {
      this.setState({ invalid: true });
      return;
    }
    loading(true);
    let result = await GET("callback/deposit-test", { data });
    if (result?.status && result.data) {
      this.setState({ transaction: result.data, invalid: false });
    } else {
      this.setState({ invalid: true });
    }
    loading(false);
  };

  Update = async (action) => {
    const { data, transaction } = this.state;
    if (!transaction || transaction.status !== "pending") return;

    const confirmed = await alert(
      "",
      "warning",
      `Set status to "${action.label}"?`,
      action.detail,
      "Confirm",
      "Cancel"
    );
    if (!confirmed) return;

    this.setState({ submitting: action.status });
    loading(true);
    let result = await POST("callback/deposit-test", {
      data,
      status: action.status,
    });
    loading(false);
    this.setState({ submitting: "" });

    if (result?.status && result.data) {
      // response เป็น format เดียวกับ GET: มี callback_url = ยิง callback แล้ว, is_callback = broker ตอบรับ
      const transactionData = result.data;
      const delivered = transactionData.is_callback === true;
      this.setState({ transaction: transactionData });
      const callbackText = !transactionData.callback_url
        ? "No callback URL is configured for this broker, so no callback was sent."
        : delivered
        ? "Callback delivered to the broker."
        : "Callback was sent but the broker did not respond with 200. Check the webhook logs.";
      alert(
        "",
        transactionData.callback_url && !delivered ? "warning" : "success",
        "Updated",
        `Transaction is now "${transactionData.status}". ${callbackText}`
      );
    }
  };

  renderRow = (label, value) => (
    <div className="d-flex justify-content-between border-bottom py-2">
      <small className="text-secondary me-3">{label}</small>
      <small
        className="text-end fw-semibold"
        style={{ wordBreak: "break-all" }}
      >
        {value === null || value === undefined || value === "" ? "-" : value}
      </small>
    </div>
  );

  render() {
    const { transaction, invalid, submitting } = this.state;
    const isPending = transaction?.status === "pending";
    const isLinkExpired = transaction?.is_link_expired === true;
    const canAct = isPending && !isLinkExpired && !submitting;

    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img alt="logo" src={LOGO} className="w-75" style={{ minWidth: 350 }} />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img alt="logo" src={LOGO} style={{ width: "60%", minWidth: 400 }} />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <div className="d-flex align-items-center mb-2">
                <h3 className="fw-bold text-dark mb-0 me-2">Deposit Test</h3>
                <span className="badge bg-warning text-dark">SANDBOX</span>
              </div>
              <div className="mb-3">
                <small>
                  Simulate the payment result of this deposit. Each button
                  updates the transaction status and sends the matching
                  callback to the broker, exactly as a real gateway would.
                </small>
              </div>

              {invalid ? (
                <div className="alert alert-warning">
                  Invalid or unknown deposit link. Create a new deposit from the
                  partner API and scan the QR again.
                </div>
              ) : !transaction ? null : (
                <div>
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold">Transaction</span>
                        {StatusTnx(transaction.status)}
                      </div>
                      {this.renderRow("Ref No", transaction.ref_no)}
                      {this.renderRow("Reference ID", transaction.reference_id)}
                      {this.renderRow("Amount", `${transaction.amount} ${transaction.currency}`)}
                      {this.renderRow("Callback URL", transaction.callback_url)}
                      {this.renderRow("Created", formatDateTime(transaction.created_at))}
                      {this.renderRow("Link Expires", formatDateTime(transaction.link_expired_at))}
                    </div>
                  </div>

                  {!transaction.callback_url && (
                    <div className="alert alert-warning py-2">
                      <small>
                        This merchant has no deposit callback URL configured. The
                        status will still be updated, but no callback will be
                        sent.
                      </small>
                    </div>
                  )}

                  {isLinkExpired && isPending && (
                    <div className="alert alert-danger py-2">
                      <small>
                        This test link has expired. Create a new deposit and
                        scan the new QR.
                      </small>
                    </div>
                  )}

                  {!isPending && (
                    <div className="alert alert-info py-2">
                      <small>
                        This transaction is already{" "}
                        <b>{transaction.status}</b>. Create a new deposit to
                        test another result.
                      </small>
                    </div>
                  )}

                  <div className="row g-2 mb-3">
                    {ACTIONS.map((action) => (
                      <div className="col-12 col-sm-4" key={action.status}>
                        <button
                          type="button"
                          className={`btn ${
                            canAct ? action.className : "btn-secondary"
                          } w-100`}
                          style={canAct ? action.style : undefined}
                          disabled={!canAct}
                          onClick={() => this.Update(action)}
                        >
                          {submitting === action.status
                            ? "Sending..."
                            : action.label}
                        </button>
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100 mb-3"
                    onClick={this.Get}
                  >
                    Refresh
                  </button>
                </div>
              )}

              <div className="w-100 text-center">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
